import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/block/[page]/_client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TranslationsProvider.tsx");
